import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { IssuerAPIService } from '../services/issuer-api.service';
declare function CheckforSession(targetid): any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare function LoadSettingsDropdown(): any;
declare function MagnifierONOFF(): any;
declare function MagnifierEnableDisable(targetid): any;
declare function SettingsVoice(targetid): any;
declare function increaseFontSize(): any;
declare function decreaseFontSize(): any;
declare function resetFontSize(): any;
declare function increaseVoiceSpeed(): any;
declare function decreaseVoiceSpeed(): any;
declare function resetVoiceSpeed(): any;
declare function voiceforincreasedecrease(targetid): any;
declare function FontSizeSettings(): any;
declare function btnToggle(): any;
declare function btnToggleNew(): any;
declare function ADAControllerWithTargetID(targetid): any;
declare var $: any;
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  pathname = '';
  IsLogin: boolean;
  username: string;
  lastLogin: string;
  isSelectObligor_status: Boolean = false;
  current_Component: string = "";
  ReviewToolkitTabsCount: string;
  constructor(private router: Router, private IssuerApi: IssuerAPIService) {

  }

  onKeyUp(event: any) {
    debugger;
    if (event.target.id == "decreasevoice" && event.keyCode == 13) {
      decreaseVoiceSpeed();
      voiceforincreasedecrease(event.target.id)
      return;
    }
    if (event.target.id == "increasevoice" && event.keyCode == 13) {
      increaseVoiceSpeed();
      voiceforincreasedecrease(event.target.id)
      return;
    }
    if (event.target.id == "voicespeed" && event.keyCode == 13) {
      resetVoiceSpeed();
      voiceforincreasedecrease(event.target.id)
      return;
    }
    if (event.target.id == "darkertheme" && event.keyCode == 13) {
      var darkerthemeBtn = <HTMLButtonElement>document.getElementById('btnDarkTheme');
      if (darkerthemeBtn.disabled == true) {
        event.preventDefault();
        return;
      }
      document.getElementById('theme').setAttribute('href', 'assets/style-sheet/mastertheme.css');
      if ($('#btnDarkTheme').val() == "OFF") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "OFF";
        $('#btnDarkTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnDarkTheme').val() == "ON") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "ON";
        $('#btnDarkTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "lighttheme" && event.keyCode == 13) {
      var LightThemeBtn = <HTMLButtonElement>document.getElementById('btnLightTheme');
      if (LightThemeBtn.disabled == true) {
        event.preventDefault();
        return;
      }
      document.getElementById('theme').setAttribute('href', 'assets/css/master.css');
      if ($('#btnLightTheme').val() == "ON") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "ON";
        $('#btnLightTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnLightTheme').val() == "OFF") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "OFF";
        $('#btnLightTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        SettingsVoice(event.target.id);
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "captiononoff" && event.keyCode == 13) {
      if ($('#btnOnOff').val() == "OFF") {
        $('#btnOnOff').val('ON')
        $('#captionhideshow').show();
        $('#hidglbVarOnOff').val('ON');
      }
      else {
        $('#captionhideshow').hide();
        $('#btnOnOff').val('OFF')
        $('#hidglbVarOnOff').val('OFF');
      }
      SettingsVoice(event.target.id);
      return;
    }
    if (event.target.id == "magnifier" && event.keyCode == 13 && event.keyCode == 27) {
      if ($('#btnMagnify').val() == "DISABLE") {
        $('#btnMagnify').val('ENABLE')
        $('#hdnMagnifierDisable').val('ENABLE');
        document.getElementById("settings").click();
        document.getElementById("SkipMainContent").focus();
        return;

      }
      else {
        $('#btnMagnify').val('DISABLE')
        $('#hdnMagnifierDisable').val('DISABLE');
      }
      SettingsVoice(event.target.id);
      MagnifierEnableDisable($('#hdnMagnifierDisable').val());
      return;
    }
    if (event.target.id == "voiceannotation" && event.keyCode == 13) {
      if ($('#btnVoiceAnnotation').val() == "OFF") {
        $('#btnVoiceAnnotation').val('ON');
        $('#hidVoiceOnOff').val('ON');
        $('#btnPlayPause').css('display', 'block');
      }
      else {
        $('#btnVoiceAnnotation').val('OFF');
        $('#hidVoiceOnOff').val('OFF');
        $('#btnPlayPause').css('display', 'none');
      }
    }
    if ((event.target.id == "decreaseFont" || event.target.id == "IncreaseFont" || event.target.id == "ResetFont"
      || event.target.id == "voiceannotation" || event.target.id == "captiononoff"
      || event.target.id == "decreasevoice" || event.target.id == "increasevoice" || event.target.id == "voicespeed"
      || event.target.id == "darkertheme" || event.target.id == "lighttheme") && event.keyCode == 13) {
      debugger;
      SettingsVoice(event.target.id);
    }

    if (event.target.id == "decreaseFont" && event.keyCode == 13) {
      decreaseFontSize();
      return;
    }
    if (event.target.id == "IncreaseFont" && event.keyCode == 13) {
      increaseFontSize();
      return;
    }
    if (event.target.id == "ResetFont" && event.keyCode == 13) {
      resetFontSize();
      return;
    }
    if ((event.target.id == "settings" || event.target.id == "IncreaseFont" || event.target.id == "decreaseFont" || event.target.id == "ResetFont"
      || event.target.id == "voiceannotation" || event.target.id == "decreasevoice" || event.target.id == "increasevoice" || event.target.id == "voicespeed"
      || event.target.id == "captiononoff" || event.target.id == "darkertheme" || event.target.id == "lighttheme" || event.target.id == "magnifier") && (event.keyCode == 27)) {
      document.getElementById("settings").click();
      //responsiveVoiceSpeak("Skip to Main Content", "This will bypass the header menu and go to the main content of the page. Use Enter to select or use tab to go to the next field.");
      //document.getElementById("SkipMainContent").focus();
      this.onFocus(event);
      return;
    }
     
    //this.pathname = window.location.pathname;
    // to get exact url and find appropriate component path 
    this.pathname = window.location.href;
    if (event.target.id == "DacBondLogo" && event.keyCode == 13) {
      if (this.pathname.includes("registration") || this.pathname.includes("IssuersandObligors") || this.pathname.includes("DACForInvestors") || this.pathname.includes("dmca")
        || this.pathname.includes("legal-information") || this.pathname.includes("help") || this.pathname.includes("sitemap") || this.pathname.includes("Accessingwebcasts")
        || this.pathname.includes("investor-browse-filing-types") || this.pathname.includes("investor-browse-borrowing-documents") || this.pathname.includes("Annualfinancial") || this.pathname.includes("Budgets") || this.pathname.includes("Interim")
        || this.pathname.includes("Failure") || this.pathname.includes("OtherFinancial") || this.pathname.includes("OtherEvent") || this.pathname.includes("RatingChange")
        || this.pathname.includes("Unscheduled") || this.pathname.includes("BondCalls") || this.pathname.includes("browse-obligor") || this.pathname.includes("aboutus")
        || this.pathname.includes("aboutus") || this.pathname.includes("aboutUsSecurities") || this.pathname.includes("PostIssuanceTaxComplianceComponent")
        || this.pathname.includes("ask-aquestion")) {
        this.Redirect_DashBoard(event)
       
        return;
      }
    }

   if (event.target.id == "settings" && event.keyCode == 9) {
      responsiveVoiceSpeak("Settings", "Using Settings you can adjust the accessibility control parameters of the application. Use Enter Key to access the Settings. Use tab to move through the list of controls. Use Enter key to activate a control. At any time use the Escape key to get back to the main page. Use tab to go to the next field.");
    }

    if (event.target.id == "SkipMainContent" && event.keyCode == 9) {
      ADAControllerWithTargetID(event.target.id);
      responsiveVoiceSpeak("Skip to Main Content", "This will bypass the header menu and go to the main content of the page. Use Enter to select or use tab to go to the next field.");
    }
    if (event.target.id == "homePageTab" && event.keyCode == 9) {
      responsiveVoiceSpeak("My Dac", "Use enter key to select this link or use tab to go to the next field.");
    }
    if (event.target.id == "divLogOut" && event.keyCode == 9) {
      responsiveVoiceSpeak("Logout", "On logout you shall be taken back to the home page of dacbond.com. Use Enter to select or use tab to go to the next field.");
    }
    if (event.target.id == "loginPage" && event.keyCode == 9) {
      responsiveVoiceSpeak("Login", "Use enter key to select this link or use tab to go to the next field.");
    }
    if (event.target.id == "decreaseFont" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Decrease Font Size. Use Enter key to decrease font size or use tab to go to the next field.");
    }
    if (event.target.id == "IncreaseFont" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Increase Font Size. Use Enter key to increase font size or use tab to go to the next field.");
    }
    if (event.target.id == "ResetFont" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Reset Font Size. Use Enter key to reset font size or use tab to go to the next field.");
    }
    if (event.target.id == "voiceannotation" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Voice Annotation On/Off toggle. Use Enter key to toggle voice On/Off, or use tab to go to the next field.");
    }
    if (event.target.id == "decreasevoice" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Decrease Voice Speed. Use Enter key to decrease voice speed or use tab to go to the next field.");
    }
    if (event.target.id == "increasevoice" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Increase Voice Speed. Use Enter key to increase voice speed or use tab to go to the next field.");
    }
    if (event.target.id == "voicespeed" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Reset Voice Speed. Use Enter key to reset voice speed or use tab to go to the next field.");
    }
    if (event.target.id == "captiononoff" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Caption On/Off toggle. Use Enter key to toggle caption On/Off, or use tab to go to the next field.");
    }
    if (event.target.id == "darkertheme" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Dark Theme. Use Enter key to set dark theme, or use tab to go to the next field.");
    }
    if (event.target.id == "lighttheme" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Light Theme. Use Enter key to set light theme, or use tab to go to the next field.");
    }
    if (event.target.id == "magnifier" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Magnifier enlarges the text under the mouse cursor. Use Enter key to enable or disable. Use tab to go to the next field.");
    }
    if (event.target.id == "DacBondLogo" && event.keyCode == 9) {
      responsiveVoiceSpeak("", "Dac Bond Logo use tab to go to the next field.");
      return;
    }

    if ((event.target.id == "userdetail") && (event.keyCode == 9 && !event.shiftKey)) {
      debugger;
      //document.getElementById("settings").toggle();
      btnToggleNew();
     // document.getElementById("settings").click();
      document.getElementById("userdetail").focus();
      var userDetail = "";
      if (localStorage.getItem("User_Name"))
        userDetail = localStorage.getItem("User_Name")
      if (userDetail != "") {
        responsiveVoiceSpeak("Username", " You are logged in as " + userDetail + ". Use tab to go to the next field.");
      }

    }

    if (event.target.id == "divLogOut" && event.keyCode == 13) {
      this.loadLogoutAccount();
      return;
    }

    if (event.target.id == "divLogOut" && event.keyCode == 9 && event.keyCode == 13) {
      debugger;
      responsiveVoiceSpeak("Logout", " On logout you shall be taken back to the home page of dacbond.com. Use Enter to select or use tab to go to the next field.");
    }

    if (event.target.id == "selectobligor" && event.keyCode == 9) {
      responsiveVoiceSpeak("Select Obligor", "There are multiple obligors. Please choose an obligor to access its toolkit. Use enter to select this link or use tab to go to the next field.");
      return;
    }

    if (event.target.id == "selectobligor" && event.keyCode == 13) {
      this.onObligor_ReviewToolKit(event);
      return;
    }
    if (event.target.id == "lasLogin" && event.keyCode == 9) {
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("lasLogin").innerText, "lasLogin", event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
  
      return;
    }
  };

  onClick(event: any) {
    debugger;
    if (event.target.id == "btndecreasevoice") {
      decreaseVoiceSpeed();
      return;
    }
    if (event.target.id == "btnincreasevoice") {
      increaseVoiceSpeed();
      return;
    }
    if (event.target.id == "btnresetvoice") {
      resetVoiceSpeed();
      return;
    }
    if (event.target.id == "btnDarkTheme") {
      document.getElementById('theme').setAttribute('href', 'assets/style-sheet/mastertheme.css');
      if ($('#btnDarkTheme').val() == "OFF") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "OFF";
        $('#btnDarkTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnDarkTheme').val() == "ON") {
        var lighttheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        lighttheme.value = "ON";
        $('#btnDarkTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "btnLightTheme") {
      document.getElementById('theme').setAttribute('href', 'assets/css/master.css');
      if ($('#btnLightTheme').val() == "ON") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "ON";
        $('#btnLightTheme').val('OFF');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = true;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = false;
        $('#hdnDarkTheme').val('ON');
        $('#hdnLightTheme').val('OFF');
        return;
      }
      if ($('#btnLightTheme').val() == "OFF") {
        var darkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        darkTheme.value = "OFF";
        $('#btnLightTheme').val('ON');
        var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
        btnDarkTheme.disabled = false;
        var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
        btnLightTheme.disabled = true;
        $('#hdnDarkTheme').val('OFF');
        $('#hdnLightTheme').val('ON');
        return;
      }
    }
    if (event.target.id == "fontDecrease") {
      decreaseFontSize();
    }
    if (event.target.id == "fontIncrease") {
      increaseFontSize();
    }
    if (event.target.id == "resetFontSize") {
      resetFontSize();
    }
   // this.pathname = window.location.pathname;
    // to get url and find out appropariate component path
    this.pathname = window.location.href;
    if (event.target.innerText == "Skip to Main Content") {
      if (this.pathname.includes("dmca")) {
        document.getElementById("lblDMCA").focus();
        document.getElementById("lblDMCA").tabIndex = 20;
        responsiveVoiceSpeak("", "DMCA. Use tab to go to the description.");
      }
      if (this.pathname.includes("legal-information")) {
        document.getElementById("lblLegalInfo").focus();
        document.getElementById("lblLegalInfo").tabIndex = 20;
        responsiveVoiceSpeak("", "Legal information. Use tab to go to the description.");
      }

      if (this.pathname.includes("aboutus")) {
        document.getElementById("lblabout").focus();
        document.getElementById("lblabout").tabIndex = 20;
        responsiveVoiceSpeak("About Us", "Use tab to go to the first section.");
      }
      if (this.pathname.includes("help")) {
        document.getElementById("lblhelp").focus();
        document.getElementById("lblhelp").tabIndex = 20;
        responsiveVoiceSpeak("", "Help. The following table consist the commands for various functions on this site. Use tab to traverse through the table or at any time, use Escape key to exit the table and go to the footer. Use tab to go the table.");
      }
      if (this.pathname.includes("sitemap")) {
        document.getElementById("lblSitemap").focus();
        document.getElementById("lblSitemap").tabIndex = 21;
        responsiveVoiceSpeak("", "Sitemap. Use tab to go to the first link.");
      }
     

      if (this.pathname.includes("compliance-review")) {
        document.getElementById("lblComplianceReview").focus();
        document.getElementById("lblComplianceReview").tabIndex = 20;        
        responsiveVoiceSpeak("", "Compliance toolkit. Heading 1. Here you can access multiple sections to access information associated with this obligor. There are " + this.ReviewToolkitTabsCount + " sections available. Use tab to go to the first section.");
      }
      if (this.pathname.includes("mydac")) {
        document.getElementById("lblmydac").focus();
        document.getElementById("lblmydac").tabIndex = 20;
        responsiveVoiceSpeak("", "My Dac. Heading 1. Use tab to go to the next field.");
      }
      if (this.pathname.includes("archivedcurrentdocuments")) {
        document.getElementById("lblarchivedcurrentdocuments").focus();
        document.getElementById("lblarchivedcurrentdocuments").tabIndex = 20;
        responsiveVoiceSpeak("", "ARCHIVED AND CURRENT DOCUMENTS.");
      }
      if (this.pathname.includes("continuingeducation")) {
        document.getElementById("lblContinuing").focus();
        document.getElementById("lblContinuing").tabIndex = 20;
        responsiveVoiceSpeak("", "Continuing Education. This page supports Continuing Education by providing access to webinars. Both Upcoming and On-Demand Webinars are available under the respective tabs. Tab to the go to the next field.");
      }

      if (this.pathname.includes("browse-obligor")) {
        document.getElementById("BrowseObligors").focus();
        document.getElementById("BrowseObligors").tabIndex = 21;
        responsiveVoiceSpeak("", "BROWSE OBLIGORS. The page is provided with a search box and an alphabetical filter to search for Obligor.  Use tab to go to the search box.");
      }

      if (this.pathname.includes("IssuersandObligors")) {
        document.getElementById("lblIssuersandObligors").focus();
        document.getElementById("lblIssuersandObligors").tabIndex = 21;
        responsiveVoiceSpeak("", "Issuers and Obligors.");
      }
      if (this.pathname.includes("DACForInvestors")) {
        document.getElementById("lblInvestors").focus();
        document.getElementById("lblInvestors").tabIndex = 21;
        responsiveVoiceSpeak("", "The DAC Repository provides investors with one stop shopping for issuers' and obligors' municipal and direct/taxable disclosure filings.");
      }
      if (this.pathname.includes("login")) {
        document.getElementById("txtUserName").focus();
        document.getElementById("txtUserName").tabIndex = 22;
        responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");
      }
      if (event.target.id == "SkipMainContentfooter") {
        document.getElementById("SkipMainContent").focus();
        document.getElementById("SkipMainContent").tabIndex = 17;
      }
      //if (event.target.id == "setting" && (event.shiftKey && event.keyCode == 9)) {
      //  this.onLoginOpen(event);
      //  return;
      //}

      if (this.pathname.includes("reviewtoolkit")) {
        document.getElementById("reviewtoolkit").focus();
        document.getElementById("reviewtoolkit").tabIndex = 21;
        responsiveVoiceSpeak("", "Compliance Review Toolkit. There are multiple obligors. Select an obligor to access its toolkit. Tab to the go to the next field.");
      }
    }
  }

  onkeypress(event: any) {
    debugger;
    if (event.keyCode == 9 || event.keyCode == 13) {
      if (event.target.id == "SkipMainContentfooter") {
        document.getElementById("SkipMainContent").focus();
        document.getElementById("SkipMainContent").tabIndex = 17;
        return;
      }
    }
    //this.pathname = window.location.pathname;
    // to get url and find out appropriate component path
    this.pathname = window.location.href;
    if (event.target.innerText == "Skip to Main Content") {
      if (event.keyCode == 9 || event.keyCode == 13) {
        if (this.pathname.includes("dmca")) {
          document.getElementById("lblDMCA").focus();
          document.getElementById("lblDMCA").tabIndex = 20;
          responsiveVoiceSpeak("", "DMCA. Use tab to go to the description.");

        }
        if (this.pathname.includes("legal-information")) {
          document.getElementById("lblLegalInfo").focus();
          document.getElementById("lblLegalInfo").tabIndex = 20;
          responsiveVoiceSpeak("", "Legal information. Use tab to go to the description.");
        }

        if (this.pathname.includes("pandpcusip")) {
          document.getElementById("cusippnpdetails").focus();
          document.getElementById("cusippnpdetails").tabIndex = 20;
          responsiveVoiceSpeak("", "Cusips For Policies and Procedures. Heading 1. This page lists all available cusips. You can also search for a specific cusip.  Use escape to skip to footer. Use tab to go to the next field.");

        }


        if (this.pathname.includes("aboutus")) {
          document.getElementById("lblabout").focus();
          document.getElementById("lblabout").tabIndex = 20;
          responsiveVoiceSpeak("About Us", "Use tab to go to the first section.");

        }
        if (this.pathname.includes("help")) {
          document.getElementById("lblhelp").focus();
          document.getElementById("lblhelp").tabIndex = 20;
          responsiveVoiceSpeak("", "Help. The following table consist the commands for various functions on this site. Use tab to traverse through the table or at any time, use Escape key to exit the table and go to the footer. Use tab to go the table.");

        }
        if (this.pathname.includes("sitemap")) {
          document.getElementById("lblSitemap").focus();
          document.getElementById("lblSitemap").tabIndex = 21;
          responsiveVoiceSpeak("", "Sitemap. Use tab to go to the first link.");

        }
        if (this.pathname.includes("compliance-review")) {
          document.getElementById("lblComplianceReview").focus();
          document.getElementById("lblComplianceReview").tabIndex = 20;
          responsiveVoiceSpeak("", "Compliance toolkit. Heading 1. Here you can access multiple sections to access information associated with this obligor. There are " + this.ReviewToolkitTabsCount + " sections available. Use tab to go to the first section.");

        }
        if (this.pathname.includes("mydac")) {
          document.getElementById("lblmydac").focus();
          document.getElementById("lblmydac").tabIndex = 20;
          responsiveVoiceSpeak("", "My Dac. Heading 1. Use tab to go to the next field.");

        }
        if (this.pathname.includes("archivedcurrentdocuments")) {
          document.getElementById("lblarchivedcurrentdocuments").focus();
          document.getElementById("lblarchivedcurrentdocuments").tabIndex = 20;
          responsiveVoiceSpeak("", "Archived and Current Documents. This page lists the number of current and archived documents by their category.  The documents are categorized by their subject types. Tab to the go to the document list.");

        }
        if (this.pathname.includes("continuingeducation")) {
          document.getElementById("lblContinuing").focus();
          document.getElementById("lblContinuing").tabIndex = 20;
          responsiveVoiceSpeak("", "Continuing Education. This page supports Continuing Education by providing access to webinars. Both Upcoming and On-Demand Webinars are available under the respective tabs. Tab to the go to the next field.");

        }
        if (this.pathname.includes("browse-obligor")) {
          document.getElementById("BrowseObligors").focus();
          document.getElementById("BrowseObligors").tabIndex = 21;
          responsiveVoiceSpeak("", "BROWSE OBLIGORS. The page is provided with a search box and an alphabetical filter to search for Obligor.  Use tab to go to the search box.");

        }
        if (this.pathname.includes("IssuersandObligors")) {
          document.getElementById("lblIssuersandObligors").focus();
          document.getElementById("lblIssuersandObligors").tabIndex = 21;
          responsiveVoiceSpeak("", "Issuers and Obligors.");

        }
        if (this.pathname.includes("login")) {
          document.getElementById("txtUserName").focus();
          document.getElementById("txtUserName").tabIndex = 22;
          responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");

        }
        if (this.pathname.includes("DACForInvestors")) {
         
            document.getElementById("lblInvestors").focus();
            document.getElementById("lblInvestors").tabIndex = 21;
            responsiveVoiceSpeak("", "The DAC Repository provides investors with one stop shopping for issuers' and obligors' municipal and direct/taxable disclosure filings.");
        }
        // click on skip main content focus goes to reset password
        if (this.pathname.includes("resetpassword")) {
          document.getElementById("lblResetpassword").focus();
          document.getElementById("lblResetpassword").tabIndex = 20;
          responsiveVoiceSpeak("", "Reset Your Password?. Use tab to go to the next field.");
        }

        if (this.pathname.includes("forgotpassword")) {
         
            document.getElementById("lblForgetpassword").focus();
            document.getElementById("lblForgetpassword").tabIndex = 22;
            responsiveVoiceSpeak("", "Forgot your password. Heading 1. Use tab to go to the next field.");          
        }
        if (this.pathname.includes("reviewtoolkit")) {
          document.getElementById("reviewtoolkit").focus();
            document.getElementById("reviewtoolkit").tabIndex = 21;
            responsiveVoiceSpeak("", "Compliance Review Toolkit. There are multiple obligors. Select an obligor to access its toolkit. Tab to the go to the next field.");
          }        
      }
    }

    else    
        if (event.keyCode == 9 || event.keyCode == 13) {
          btnToggleNew();
          if (this.pathname.includes("dmca")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblDMCA").focus();
              document.getElementById("lblDMCA").tabIndex = 20;
              responsiveVoiceSpeak("", "DMCA. Use tab to go to the description.");
            }
          }
          if (this.pathname.includes("legal-information")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblLegalInfo").focus();
              document.getElementById("lblLegalInfo").tabIndex = 20;
              responsiveVoiceSpeak("", "Legal information. Use tab to go to the description.");
            }
            if (this.pathname.includes("pandpcusip")) {
              document.getElementById("cusippnpdetails").focus();
              document.getElementById("cusippnpdetails").tabIndex = 20;
              responsiveVoiceSpeak("", "Cusips For Policies and Procedures. Heading 1. This page lists all available cusips. You can also search for a specific cusip.  Use escape to skip to footer. Use tab to go to the next field.");

            }
          }
          if (this.pathname.includes("aboutus")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblabout").focus();
              document.getElementById("lblabout").tabIndex = 20;
              responsiveVoiceSpeak("About Us", "Use tab to go to the first section.");
            }
          }
          if (this.pathname.includes("help")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblhelp").focus();
              document.getElementById("lblhelp").tabIndex = 20;
              responsiveVoiceSpeak("", "Help. The following table consist the commands for various functions on this site. Use tab to traverse through the table or at any time, use Escape key to exit the table and go to the footer. Use tab to go the table.");
            }
          }
          if (this.pathname.includes("sitemap")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblSitemap").focus();
              document.getElementById("lblSitemap").tabIndex = 21;
              responsiveVoiceSpeak("", "Sitemap. Use tab to go to the first link.");
            }
          }
          if (this.pathname.includes("compliance-review")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblComplianceReview").focus();
              document.getElementById("lblComplianceReview").tabIndex = 20;
              responsiveVoiceSpeak("", "Compliance toolkit. Heading 1. Here you can access multiple sections to access information associated with this obligor. There are " + this.ReviewToolkitTabsCount + " sections available. Use tab to go to the first section.");
            }
          }
          if (this.pathname.includes("mydac")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblmydac").focus();
              document.getElementById("lblmydac").tabIndex = 20;
              responsiveVoiceSpeak("", "My Dac. Heading 1. Use tab to go to the next field.");
            }
          }
          if (this.pathname.includes("archivedcurrentdocuments")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblarchivedcurrentdocuments").focus();
              document.getElementById("lblarchivedcurrentdocuments").tabIndex = 20;
              responsiveVoiceSpeak("", "Archived and Current Documents. This page lists the number of current and archived documents by their category.  The documents are categorized by their subject types. Tab to the go to the document list.");
            }
          }
          if (this.pathname.includes("continuingeducation")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblContinuing").focus();
              document.getElementById("lblContinuing").tabIndex = 20;
              responsiveVoiceSpeak("", "Continuing Education. This page supports Continuing Education by providing access to webinars. Both Upcoming and On-Demand Webinars are available under the respective tabs. Tab to the go to the next field.");
            }
          }
          if (this.pathname.includes("browse-obligor")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("BrowseObligors").focus();
              document.getElementById("BrowseObligors").tabIndex = 21;
              responsiveVoiceSpeak("", "BROWSE OBLIGORS. The page is provided with a search box and an alphabetical filter to search for Obligor.  Use tab to go to the search box.");
            }
          }
          if (this.pathname.includes("IssuersandObligors")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblIssuersandObligors").focus();
              document.getElementById("lblIssuersandObligors").tabIndex = 21;
              responsiveVoiceSpeak("", "Issuers and Obligors.");
            }
          }
          if (this.pathname.includes("login")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("txtUserName").focus();
              document.getElementById("txtUserName").tabIndex = 22;
              responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");
            }
          }
          if (this.pathname.includes("DACForInvestors")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblInvestors").focus();
              document.getElementById("lblInvestors").tabIndex = 21;
              responsiveVoiceSpeak("", "The DAC Repository provides investors with one stop shopping for issuers' and obligors' municipal and direct/taxable disclosure filings.");
            }
          }

          if (this.pathname.includes("forgotpassword")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("lblForgetpassword").focus();
              document.getElementById("lblForgetpassword").tabIndex = 22;
              responsiveVoiceSpeak("", "Forgot your password. Heading 1. Use tab to go to the next field.");
            }
          }


          if (this.pathname.includes("reviewtoolkit")) {
            if (localStorage.getItem("User_Name")) {
              document.getElementById("userdetail").focus();
              responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
            }
            else {
              document.getElementById("reviewtoolkit").focus();
              document.getElementById("reviewtoolkit").tabIndex = 21;
              responsiveVoiceSpeak("", "Compliance Review Toolkit. There are multiple obligors. Select an obligor to access its toolkit. Tab to the go to the next field.");
            }
          }

    }
  }

  toggle(event: any) {
    debugger;
    if (event.target.id == "btnOnOff") {
      if ($('#btnOnOff').val() == "OFF") {
        $('#btnOnOff').val('ON')
        $('#captionhideshow').show();
        $('#hidglbVarOnOff').val('ON');
      }
      else {
        $('#captionhideshow').hide();
        $('#btnOnOff').val('OFF')
        $('#hidglbVarOnOff').val('OFF');
      }
    }
    if (event.target.id == "btnVoiceAnnotation") {
      if ($('#btnVoiceAnnotation').val() == "OFF") {
        $('#btnVoiceAnnotation').val('ON');
        $('#hidVoiceOnOff').val('ON');
        $('#btnPlayPause').css('display', 'block');
      }
      else {
        $('#btnVoiceAnnotation').val('OFF');
        $('#hidVoiceOnOff').val('OFF');
        $('#btnPlayPause').css('display', 'none');
      }
    }
    if (event.target.id == "btnMagnify") {
      if ($('#btnMagnify').val() == "DISABLE") {
        $('#btnMagnify').val('ENABLE')
        $('#hdnMagnifierDisable').val('ENABLE');
        MagnifierEnableDisable("ENABLE");
      }
      else {
        $('#btnMagnify').val('DISABLE')
        $('#hdnMagnifierDisable').val('DISABLE');
        MagnifierEnableDisable("DISABLE");
      }
    }
  }

  LogoutAccount() {
    this.loadLogoutAccount();
  }

  // Logout Account
  loadLogoutAccount() {
    this.IssuerApi.LogoutAccount().subscribe(data => {
      document.getElementById("logOutPage").click();
    });
    CheckforSession("LogoutPageHit");
    this.checksessionStorage();
  }

  checksessionStorage() {
    if (localStorage.length == 0) {
      document.getElementById("divLogOut").style.display = "none";
    }
    if (localStorage.length > 1) {
      document.getElementById("divLogOut").style.display = "block";
    }
  }

  ngOnInit() {
    debugger;
    //check session for specific page
    this.PageValidSessionState();

    // get session data
    this.IssuerApi.GetUserDataFromLocalStorage();
    // To set username and last login value from local storage, or hide header controls if not login
    this.IssuerApi._userName.subscribe(response => {
      this.username = response;
      debugger;
      if (this.username == "") {
        document.getElementById("liUserDetail").style.display = "none";
        document.getElementById("liLastLogin").style.display = "none";
        document.getElementById("liSelectObligor").style.display = "none";
        document.getElementById("liMyDAC").style.display = "none";
        document.getElementById("liLogout").style.display = "none";
      }

      if (this.username != "") {

        document.getElementById("liUserDetail").style.display = "block";
        document.getElementById("liLastLogin").style.display = "block";
        document.getElementById("liSelectObligor").style.display = "block";
        document.getElementById("liMyDAC").style.display = "block";
        document.getElementById("liLogout").style.display = "block";
        debugger;

        this.pathname = window.location.href;

        if (this.pathname.includes("mydac")) {

          this.current_Component = "mydac";

        }

        if (this.current_Component != "") {
          document.getElementById("liMyDAC").style.display = "none";
        }
        else
          document.getElementById("liMyDAC").style.display = "block";
      }
    });

    this.IssuerApi._lastLogin.subscribe(response => {
      this.lastLogin = response;
      $("#hdDate").val(response);
      if (this.username != "")
        this.IsLogin = true;

    });

    this.IssuerApi._IselectObligor.subscribe(response => {
      debugger;

      if (response == "1") {
        document.getElementById("liSelectObligor").style.display = "none";
      }
      else {
        if (this.username != "") {
          if (response == "2") {
            document.getElementById("liSelectObligor").style.display = "block";
          }
          else {
            document.getElementById("liSelectObligor").style.display = "none";
          }
        }
        else {
          document.getElementById("liSelectObligor").style.display = "none";
        }
      }


    });
    // end

  //  this.loadCTAuthorizations(localStorage.getItem("OBLIGOR_ID"));
  //  MagnifierONOFF();
    LoadSettingsDropdown();
    window.scrollTo(0, 0); // Set scroll postion top when any component load.
    document.getElementById("pageloadid").focus();
  }

  PageValidSessionState() {

    this.pathname = window.location.href;

    if ((this.pathname.includes("cusip")) || (this.pathname.includes("pandpcusip")) || (this.pathname.includes("compliance-review"))
      || (this.pathname.includes("archivedcurrentdocuments"))
      || (this.pathname.includes("continuingeducation")) || (this.pathname.includes("browse-obligor"))
      || (this.pathname.includes("IssuersandObligors")) || (this.pathname.includes("DACForInvestors") || (this.pathname.includes("reviewtoolkit")))) {
      debugger
      this.IssuerApi.GetIssuerBrowseBulletinBoard().subscribe(data => {
        debugger;
        if (!this.CheckLocalStorage()) {
          this.RemoveLocalStorage();
          this.router.navigate(['/login']);
        }
      },
        error => {
          debugger;
          if (error.status === 403) {
            document.getElementById("overlay").style.display = "none";
            this.RemoveLocalStorage();
            this.router.navigate(['/login']);
          }

        });

    }
  }

  // check local storage 
  CheckLocalStorage(): boolean {
    if (localStorage.getItem("User_Name")) {
      return true;
    }
    else {
      return false;
    }

  }

  // remove local storage
  RemoveLocalStorage() {
    localStorage.removeItem("User_Name");
    localStorage.removeItem("Last_Login")
    localStorage.removeItem("IsSelect_Obligor")
  }

  // Load CT Authorizations
  loadCTAuthorizations(obligorId: string) {
    debugger;
    this.IssuerApi.GetCTAuthorizations(obligorId).subscribe(data => {
      if (data["obligor"]["authorizedObligorTabs"].length > 0) {
        this.ReviewToolkitTabsCount = data["obligor"]["authorizedObligorTabs"].length.toString();
      }
    });
  }

  ngAfterViewInit() {
    debugger;

    // Set Magnifier button Enable/Disable
    if ($('#hdnMagnifierDisable').val() == "ENABLE") {
      $('#btnMagnify').val('ENABLE')
      MagnifierEnableDisable("ENABLE");
    }
    else {
      $('#btnMagnify').val('DISABLE')
      MagnifierEnableDisable("DISABLE");
    }

    // Set application level Light and Dark Theme button enable/disable on the basis of Settings.
    // Darker Theme
    var btnDarkTheme = <HTMLButtonElement>document.getElementById("btnDarkTheme");
    var btnLightTheme = <HTMLButtonElement>document.getElementById("btnLightTheme");
    if ($('#hdnDarkTheme').val() == "OFF") {
      btnDarkTheme.value = "OFF";
      btnLightTheme.value = "ON";
      btnDarkTheme.disabled = false;
      btnLightTheme.disabled = true;
    }
    if ($('#hdnDarkTheme').val() == "ON") {
      btnDarkTheme.value = "ON";
      btnLightTheme.value = "OFF";
      btnDarkTheme.disabled = true;
      btnLightTheme.disabled = false;
    }
    // Lighter Theme        
    if ($('#hdnLightTheme').val() == "OFF") {
      btnDarkTheme.value = "ON";
      btnLightTheme.value = "OFF";
      btnDarkTheme.disabled = true;
      btnLightTheme.disabled = false;
    }
    if ($('#hdnLightTheme').val() == "ON") {
      btnDarkTheme.value = "OFF";
      btnLightTheme.value = "ON";
      btnDarkTheme.disabled = false;
      btnLightTheme.disabled = true;
    }

    // Set font size on application level on the basis of Settings.
    FontSizeSettings();
  }
  // to set reviewtoolkit page set pagination local storage to MD
  onObligor_ReviewToolKit(event: any) {
    localStorage.setItem("Page_Navigation", "MD");
    this.router.navigate(['/reviewtoolkit']);
  }

  onFocus(event: any) {
    debugger;
    // to get appropriate component path fro specified url
    // this.pathname = window.location.pathname;
    this.pathname = window.location.href;
    if (event.keyCode == 27) {
      if (this.pathname.includes("dmca")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblDMCA").focus();
          document.getElementById("lblDMCA").tabIndex = 20;
          responsiveVoiceSpeak("", "DMCA. Use tab to go to the description.");
        }
      }
      if (this.pathname.includes("legal-information")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblLegalInfo").focus();
          document.getElementById("lblLegalInfo").tabIndex = 20;
          responsiveVoiceSpeak("", "Legal information. Use tab to go to the description.");
        }
      }
      if (this.pathname.includes("aboutus")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblabout").focus();
          document.getElementById("lblabout").tabIndex = 20;
          responsiveVoiceSpeak("About Us", "Use tab to go to the first section.");
        }
      }
      if (this.pathname.includes("help")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblhelp").focus();
          document.getElementById("lblhelp").tabIndex = 20;
          responsiveVoiceSpeak("", "Help. The following table consist the commands for various functions on this site. Use tab to traverse through the table or at any time, use Escape key to exit the table and go to the footer. Use tab to go the table.");
        }
      }
      if (this.pathname.includes("sitemap")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblSitemap").focus();
          document.getElementById("lblSitemap").tabIndex = 21;
          responsiveVoiceSpeak("", "Sitemap. Use tab to go to the first link.");
        }
      }
      if (this.pathname.includes("compliance-review")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblComplianceReview").focus();
          document.getElementById("lblComplianceReview").tabIndex = 20;
          responsiveVoiceSpeak("", "Compliance Review Toolkit - Overview Page.");
        }
      }

      if (this.pathname.includes("mydac")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
        }
        else {
          document.getElementById("lblmydac").focus();
          document.getElementById("lblmydac").tabIndex = 20;
          responsiveVoiceSpeak("", "My Dac. Heading 1. Use tab to go to the next field.");
        }
      }
      if (this.pathname.includes("archivedcurrentdocuments")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblarchivedcurrentdocuments").focus();
          document.getElementById("lblarchivedcurrentdocuments").tabIndex = 20;
          responsiveVoiceSpeak("", "Archived and Current Documents. This page lists the number of current and archived documents by their category.  The documents are categorized by their subject types. Tab to the go to the document list.");
        }
      }
      if (this.pathname.includes("continuingeducation")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblContinuing").focus();
          document.getElementById("lblContinuing").tabIndex = 20;
          responsiveVoiceSpeak("", "Continuing Education. This page supports Continuing Education by providing access to webinars. Both Upcoming and On-Demand Webinars are available under the respective tabs. Tab to the go to the next field.");
        }
      }
      if (this.pathname.includes("browse-obligor")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("BrowseObligors").focus();
          document.getElementById("BrowseObligors").tabIndex = 21;
          responsiveVoiceSpeak("", "BROWSE OBLIGORS.");
        }
      }
      if (this.pathname.includes("IssuersandObligors")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblIssuersandObligors").focus();
          document.getElementById("lblIssuersandObligors").tabIndex = 21;
          responsiveVoiceSpeak("", "Issuers and Obligors.");
        }
      }
      if (this.pathname.includes("login")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("txtUserName").focus();
          document.getElementById("txtUserName").tabIndex = 22;
          responsiveVoiceSpeak("", "Username. Please enter your username. This is a mandatory field. Use tab to go to the next field.");
        }
      }
      if (this.pathname.includes("DACForInvestors")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblInvestors").focus();
          document.getElementById("lblInvestors").tabIndex = 21;
          responsiveVoiceSpeak("", "The DAC Repository provides investors with one stop shopping for issuers' and obligors' municipal and direct/taxable disclosure filings.");
        }
      }

      if (this.pathname.includes("forgotpassword")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("lblForgetpassword").focus();
          document.getElementById("lblForgetpassword").tabIndex = 22;
          responsiveVoiceSpeak("", "Forgot your password. Heading 1. Use tab to go to the next field.");
        }
      }


      if (this.pathname.includes("reviewtoolkit")) {
        if (localStorage.getItem("User_Name")) {
          document.getElementById("userdetail").focus();
          responsiveVoiceSpeak("Username", " You are logged in as " + localStorage.getItem("User_Name") + ". Use tab to go to the next field.");
        }
        else {
          document.getElementById("reviewtoolkit").focus();
          document.getElementById("reviewtoolkit").tabIndex = 21;
          responsiveVoiceSpeak("", "Compliance Review Toolkit. There are multiple obligors. Select an obligor to access its toolkit. Tab to the go to the next field.");
        }
      }

    }
  }

  // redirect to dashboard and login page as login or not
  Redirect_DashBoard(event: any) {
    debugger;
    if (localStorage.getItem("User_Name")) {
      this.router.navigate(['/mydac']);
    }
    else {
      this.router.navigate(['/login']);
    }
  }

}
